(function () {
    'use strict';

    function requestDemoDataService($http) {

        var baseUrl = '[BuildifyApiHost]/api/';

        function requestDemo(request) {
            return $http.post(baseUrl + 'requestdemo', request).then(function (response) {
                return response.data;
            });
        }

        return {
            requestDemo: requestDemo
        }
    }

    requestDemoDataService.$inject = ['$http'];

    angular.module('ecap.registration').service('requestDemoDataService', requestDemoDataService);
})();
